import React from 'react';
import MuiLink from '@material-ui/core/Link';
import Avatar from '@material-ui/core/Avatar';
import resizeImageUrl from '@afosto/utils/resizeImageUrl';
import ProductSkuFormatter from '@afosto/utils-react/formatters/ProductSkuFormatter';
import ShipmentFormatter from '@afosto/utils-react/formatters/ShipmentFormatter';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const PRODUCTS_APP_ORIGIN = BASE_URL.replace('{app}', 'products');

export const productImageFormatter = (cell, row) => (
  <MuiLink
    variant="subtitle1"
    href={`${PRODUCTS_APP_ORIGIN}/products/${encodeURIComponent(row?.product?.sku)}`}
  >
    <Avatar src={resizeImageUrl(row?.product?.image, 50)} alt={row?.product?.name} />
  </MuiLink>
);

export const productSkuFormatter = cell => <ProductSkuFormatter sku={cell} />;

export const arrayLengthFormatter = cell => cell.length;

export const shipmentFormatter = (cell, row) => <ShipmentFormatter shipmentId={row?.shipment_id} />;

export default arrayLengthFormatter;
